import { createRouter, createWebHistory } from 'vue-router';
import axios from 'axios';


import MultipleChildItem from "./components/MultipleChildItem.vue";
import HomeItem from "./components/HomeItem.vue";
import AttendanceItem from './components/AttendanceItem.vue';
import Register from './components/Register.vue';
import LoginItem from './components/LoginItem.vue';
import SettingsItem from './components/SettingsItem.vue';
import GroupsItem from './components/GroupsItem.vue';
import GroupDetailsItem from './components/GroupDetailsItem.vue';
import NewGroupItem from './components/NewGroupItem.vue';
import store from './store';
import ChildSettings from './components/ChildSettingsItem.vue';
import ChildItem from './components/ChildItem.vue';
import RespItem from './components/RespItem.vue';
import ResetPassword from './components/ResetPassword.vue';
import HomeworksItem from './components/HomeworksItem.vue';
import AllEventsItem from './components/AllEventsItem.vue';
import StatisticsItem from './components/StatisticsItem.vue';
import NoShowMonthItem from './components/statistics/NoShowMonthItem.vue';
import NoShowWeekItem from './components/statistics/NoShowWeekItem.vue';
import AllWeekItem from './components/statistics/AllWeekItem.vue';
import AllMonthItem from './components/statistics/AllMonthItem.vue';
import GroupMonthItem from './components/statistics/GroupMonthItem.vue';
import GroupWeekItem from './components/statistics/GroupWeekItem.vue';
import EventInfoItem from './components/EventInfoItem.vue';
import ChildDofItem from './components/ChildDofItem.vue';
import NewRegItem from './components/NewRegItem.vue';
import CustomSettingsItem from './components/CustomSettingsItem.vue';
import ChildRegQueueItem from './components/ChildRegQueueItem.vue';
import RegisterTeacher from './components/RegisterTeacher.vue';
import TeacherSettingsItem from './components/TeacherSettingsItem.vue';
import GroupPricesItem from './components/GroupPricesItem.vue';
import BillingSettingsItem from './components/BillingSettingsItem.vue';
import BillingItem from './components/BillingItem.vue';
import PaymentStatsItem from './components/PaymentStatsItem.vue';
import GalaItem from './components/GalaItem.vue';
import PublicGalaItem from './components/PublicGalaItem.vue';
import MessageCenterItem from './components/MessageCenterItem.vue';
import SessionStatusItem from './components/SessionStatusItem.vue';
import CurrentInfoItem from './components/CurrentInfoItem.vue';
import ReceiptsItem from './components/ReceiptsItem.vue';
import CalendarsItem from './components/CalendarsItem.vue';
axios.defaults.withCredentials = true; // Include credentials (cookies)

const routes = [
    { path: '/', component: HomeItem, auth:"", nadmin: "" },
    { path: '/login', component: LoginItem, auth:"", nadmin: "" },
    { path: '/attendance', component: AttendanceItem, auth:"req", nadmin: "" },
    { path: '/gala', component: GalaItem, auth:"req", nadmin: "teach_req" },
    { path: '/public-galas', component: PublicGalaItem, auth:"req", nadmin: "" },
    { path: '/groups', component: GroupDetailsItem, auth:"req", nadmin: "teach_req" },
    { path: '/groups/:id', component: GroupDetailsItem, auth:"req", nadmin: "teach_req" },
    { path: '/settings', component: SettingsItem, auth:"req", nadmin: "", children: [
        {path: 'groups', component: GroupsItem, children: [{path: "new", component: NewGroupItem}]},
        {path: 'children', component: ChildSettings, children: [{path: "new", component: NewGroupItem}]},
        {path: 'homeworks', component: HomeworksItem},
        {path: 'events', component: AllEventsItem},
        {path: 'reg', component: NewRegItem},
        {path: 'regqueue', component: ChildRegQueueItem},
        {path: 'teacher', component:TeacherSettingsItem},
        {path: 'pricing', component: GroupPricesItem},
        {path: 'billing', component: BillingSettingsItem}
    ]},
    { path: '/message-center', component: MessageCenterItem, auth:"req", nadmin: "teach_req" },
    { path: "/statistics", component: PaymentStatsItem, auth:"req", nadmin:"teach_req" },
    { path: "/statistics/payments", component: PaymentStatsItem, auth:"req", nadmin:"teach_req" },
    { path: '/register', component: Register, auth:"", nadmin: ""},
    { path: '/children', component: MultipleChildItem, auth:"req", nadmin:""},
    { path: '/children/:id', component: ChildItem, auth:"req", nadmin:""},
    { path: '/children/:id/billing', component: BillingItem, auth:"req", nadmin:""},
    { path: '/billing', component: BillingItem, auth:"req", nadmin:""},
    { path: '/billing/:childId', component: BillingItem, auth:"req", nadmin:""},
    { path: '/dancer/:id', component: ChildItem, auth:"req", nadmin:""},
    { path: '/event/:id', component: EventInfoItem, auth:"req", nadmin:"req"},
    { path: '/cresp/:hash', component: RespItem, auth: "", nadmin: "", props: true},
    { path: '/cdrof/:hash', component: ChildDofItem, auth: "", nadmin: "", props: true},
    { path: '/custsettings', component: CustomSettingsItem, auth: "req", nadmin: "req"},
    { path: '/pwr', component: ResetPassword, auth: "", nadmin: ""},
    { path: '/register/teacher', component: RegisterTeacher, auth:"", nadmin: ""},
    { path: '/session-status', component: SessionStatusItem, auth:"req", nadmin: ""},
    { path: '/aktuális-infok', component: CurrentInfoItem, auth:"req", nadmin: "" },
    { path: '/receipts', component: ReceiptsItem, auth:"req", nadmin: "teach_req" },
    { path: '/calendars', component: CalendarsItem, auth:"req", nadmin: "" },

];

// Create the router
export const router = createRouter({
    history: createWebHistory(),
    routes,
});

import sessionManager from './sessionManager';

// Global beforeEach guard for authentication
router.beforeEach(async (to, from, next) => {
    // Check session validity for authenticated routes
    if (to.path !== '/login' && to.path !== '/register' && to.path !== '/register/teacher' && to.path !== '/pwr') {
        const isSessionValid = await sessionManager.validateSession();
        if (!isSessionValid) {
            return next('/login');
        }
    }

    const isLoggedIn = localStorage.getItem('user') !== null;
    const isAdmin = localStorage.getItem('isAdmin') === 'true';
    const isTeacher = localStorage.getItem('isTeacher') === 'true';
    const isAssistant = localStorage.getItem('isAssistant') === 'true';
    let need_auth = "";
    let need_admin = "";
    
    // Loop through routes to find the current route's auth and admin requirements
    for (let r in routes) {
        if (routes[r].path === to.path) {
            need_admin = routes[r].nadmin;
            need_auth = routes[r].auth;
        }
    }
    
    // Redirect to login if user is not logged in and they try to access / path
    if (to.path === "/" && !isLoggedIn) {
        next('/login');
    } else if (need_auth === "req" && !isLoggedIn) {
        next('/login');
    } else if ((need_admin === "req" && !isAdmin) || (need_admin === "teach_req" && !isAdmin && !isTeacher && !isAssistant)) {
        // Special case: allow teachers and assistants to access settings but not admin-only routes
        if (to.path.startsWith('/settings') && (isTeacher || isAssistant)) {
            // Check if it's an admin-only route within settings
            const adminOnlyRoutes = ['/settings/children', '/settings/reg', '/settings/regqueue'];
            if (adminOnlyRoutes.includes(to.path)) {
                next('/settings');
            } else {
                next();
            }
        } else {
            next('/');
        }
    } else {
        next();
    }
})
